export default "__VITE_ASSET__VU9e4xWw__"